import { render, staticRenderFns } from "./ComplaintSectorCards.vue?vue&type=template&id=40175337&"
import script from "./ComplaintSectorCards.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports